export default __webpack_public_path__ + "static/media/Logo Turismo-01.14513423.WebP";